module.exports = __webpack_public_path__ + "media/images/mobile-191154d95cdcd0557c34edae24c836e4.png";